import React from "react";
import { Box } from "@mui/system";
import { TableBoxProps } from "./TableBox.types";

export const TableBox = (props: TableBoxProps) => {
  const sx = {
    p: 1,
    backgroundColor: "tertiary.0",
    border: "1px solid",
    minHeight: "52px",
    borderColor: "grey.200",
    borderRadius: "8px",
    ...props.sx,
  };

  return <Box sx={sx}>{props.children}</Box>;
};
